import {CURSOR, drawExpansionIcon, drawRectangle, getTextColor, getTrimmedText, GROUP_SECTION_WIDTH, GROUP_TYPE} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class TaskGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_TASK, data);
		if (data.subTaskLevel === undefined) {
			data.subTaskLevel = 0;
		}
	}

	addSubTaskLevel(subTaskLevel){
		this.data.subTaskLevel = subTaskLevel;
		if(this.data.groups){
			this.data.groups.forEach(group => {
				group.addSubTaskLevel(subTaskLevel + 1);
			})
		}
	}

	refreshData(updatedTask) {
		this.data.name = updatedTask.name;
	}

	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, groupType, expanded} = this;
		super.draw(x, y, width, height, this);
		const {name, id, companyTaskId} = data;
		const cacheId = `${groupType}-${id}`;
		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		const textColor = getTextColor();

		const drawGroup = () => {
			const subTaskLevelOffset = data.subTaskLevel * 10;
			const xOffset = data.isInProjectGroup ? 16 : 10;
			drawRectangle(canvasContext, x + xOffset, y - 1, width - xOffset, height + 1, {
				borderColor: '#ebebee',
				borderThickness: 1,
			});

			if (data.expandable) {
				drawExpansionIcon(canvasContext, x, y, width, height, {
					expanded,
				});
			}

			canvasContext.fillStyle = data.isStarted ? textColor : '#a1a1a1';
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			canvasContext.fillText(getTrimmedText(canvasContext, name, data.task.done ? 160 : 180), x + 64 + subTaskLevelOffset, y + 18);
			canvasContext.fillStyle = '#a1a1a1';
			canvasContext.font = '700 10px ' + Util.getFontFamily();
			canvasContext.fillText(`T${companyTaskId}`, x + 24 + subTaskLevelOffset, y + 17);
			if (data.task.done) {
				const xExpanderOffset = data.expandable ? 30 : 0;
				canvasContext.strokeStyle = '#00cc66';
				canvasContext.lineWidth = 2;
				canvasContext.beginPath();
				canvasContext.moveTo(x + 244 - xExpanderOffset, y + 15);
				canvasContext.lineTo(x + 248 - xExpanderOffset, y + 19);
				canvasContext.lineTo(x + 257 - xExpanderOffset, y + 8);
				canvasContext.stroke();
				canvasContext.lineWidth = 1;
			}
		};
		drawGroup();
	}
}

export default TaskGroup;
